import {
  DIRECT_PURCHASE,
  PROCUREMENT,
  PURCHASE_ORDER,
  PURCHASE_ORDER_VIEW,
} from '@constants/internal-route.constant'
import { ROUTE_CODES } from '@constants/route-codes.constant';
import {IAppRoutes} from '@interface/common.interface'
import {lazy} from 'react'

/**
 * Procurement is the BUYING menu: the two documents that commit money to a supplier.
 *
 * <p>The chain documents the store raises and works — SPR, challan, QC, MRR — moved to
 * {@link InventoryRoutes} on 2026-09-23. Their feature CODES are unchanged, which is what makes the
 * move free of an access change: this app gates on `feature.code === routeCode`, never on
 * `auth.features.url`, so every existing grant follows the screen. Only the ACL rows' `parent_id`
 * moved, so the permission tree lists them under the group they now appear in.
 */
export const ProcurementRoutes: IAppRoutes = {
  link: PROCUREMENT,
  routeCode: ROUTE_CODES.PROCUREMENT,
  childrens: [
    {
      link: PURCHASE_ORDER,
      routeCode: ROUTE_CODES.PROCUREMENT_PO,
      element: lazy(() => import('@modules/procurement/purchase-order')),
    },
    {
      // Read-only detail. Same routeCode as the list: a missing one reads as "always allow", and
      // hiding a row is worthless if its id still opens it.
      link: PURCHASE_ORDER_VIEW({id: ':id'}),
      routeCode: ROUTE_CODES.PROCUREMENT_PO,
      element: lazy(() => import('@modules/procurement/purchase-order/View')),
    },
    {
      // Buying without an SPR. A different document on a different table (store.purchases),
      // which is why it belongs beside the purchase order rather than in the store's menu.
      link: DIRECT_PURCHASE,
      routeCode: ROUTE_CODES.INV_RECEIVE,
      element: lazy(() => import('@modules/procurement/direct-purchase')),
    },
  ],
};
